export interface Movie {
  id: string;
  title: string;
  category: string;
  year: number;
  rating: number;
  imageUrl: string;
  imageSeq: string;
  description: string;
  director: string;
  cast: string[];
  genre: string[];
  duration: string;
  region: string;
  synopsis: string;
  featured: boolean;
  isNew: boolean;
}

export const movieCategories = [
  { slug: 'all', name: '全部影片' },
  { slug: 'action', name: '动作片' },
  { slug: 'comedy', name: '喜剧片' },
  { slug: 'romance', name: '爱情片' },
  { slug: 'scifi', name: '科幻片' },
  { slug: 'horror', name: '恐怖片' },
  { slug: 'animation', name: '动画片' },
  { slug: 'tvseries', name: '电视剧' },
  { slug: 'documentary', name: '纪录片' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    category: 'scifi',
    year: 2026,
    rating: 9.2,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%20dramatic%20lighting%20warm%20golden%20red%20tones%20cinematic%20composition%20film%20grain%20texture%20epic%20space%20theme%20Chinese%20calligraphy%20title&width=600&height=840&seq=movie-liulang-3&orientation=portrait',
    imageSeq: 'movie-liulang-3',
    description: '中国科幻巨制续作，人类命运再次面临抉择，视觉特效全面升级。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    genre: ['科幻', '灾难', '冒险'],
    duration: '168分钟',
    region: '中国大陆',
    synopsis: '太阳急速老化，持续膨胀，将在百年内吞没地球。面对绝境，人类再次启动"流浪地球计划"，建造上万台行星发动机推动地球逃离太阳系。然而在这条长达2500年的宇宙流浪之路上，新的危机正悄然逼近——未知的外星力量、内部的分歧与背叛，都将考验人类文明的韧性。',
    featured: true,
    isNew: true,
  },
  {
    id: 'movie-2',
    title: '长空之王',
    category: 'action',
    year: 2025,
    rating: 8.8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20military%20action%20movie%20poster%20fighter%20jet%20dramatic%20sky%20warm%20golden%20red%20tones%20cinematic%20heroic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=movie-changkong&orientation=portrait',
    imageSeq: 'movie-changkong',
    description: '中国空军试飞员的热血传奇，惊险刺激的空中追逐战。',
    director: '刘晓世',
    cast: ['王一博', '胡军', '周冬雨', '于适', '卜钰'],
    genre: ['动作', '剧情', '军事'],
    duration: '127分钟',
    region: '中国大陆',
    synopsis: '雷宇是一名优秀的空军飞行员，经过严苛选拔成为试飞员。在队长张挺的带领下，他与战友们参与了最新型战斗机的试飞任务。在一次次极限挑战中，他们用生命和热血捍卫中国空军的荣耀，在蓝天之上书写了一段可歌可泣的英雄史诗。',
    featured: true,
    isNew: false,
  },
  {
    id: 'movie-3',
    title: '人生路不熟',
    category: 'comedy',
    year: 2025,
    rating: 8.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20road%20movie%20poster%20warm%20humorous%20style%20bright%20golden%20tones%20family%20fun%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=movie-rensheng&orientation=portrait',
    imageSeq: 'movie-rensheng',
    description: '爆笑公路喜剧，一趟笑料百出的探亲之旅。',
    director: '叫兽易小星',
    cast: ['乔杉', '范丞丞', '马丽', '张婧仪', '常远'],
    genre: ['喜剧', '公路'],
    duration: '110分钟',
    region: '中国大陆',
    synopsis: '卡车司机周东海带着准女婿万一帆去见未来的岳父岳母，结果这一路上状况百出——车子坏了、迷路了、遇到奇怪的旅人。在欢声笑语中，周东海逐渐发现这个看似不靠谱的准女婿，其实有着一颗真诚善良的心。',
    featured: true,
    isNew: true,
  },
  {
    id: 'movie-4',
    title: '消失的她',
    category: 'horror',
    year: 2025,
    rating: 8.6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20thriller%20movie%20poster%20dark%20mysterious%20atmosphere%20red%20black%20tones%20film%20noir%20style%20dramatic%20shadows%20cinematic%20composition%20film%20grain%20texture&width=600&height=840&seq=movie-xiaoshi&orientation=portrait',
    imageSeq: 'movie-xiaoshi',
    description: '悬疑惊悚烧脑大片，反转不断引人入胜，结局令人震撼。',
    director: '陈思诚',
    cast: ['朱一龙', '倪妮', '文咏珊', '杜江', '黄子琪'],
    genre: ['悬疑', '惊悚', '犯罪'],
    duration: '122分钟',
    region: '中国大陆',
    synopsis: '何非的妻子李木子在海外旅行时神秘失踪。当他报案后，一名陌生女子突然出现，声称自己就是他的妻子。在警官郑成的调查中，一个惊天大案逐渐浮出水面，真相远比想象中更加可怕。每当你以为猜到了结局，剧情就会给你一个全新的反转。',
    featured: true,
    isNew: false,
  },
  {
    id: 'movie-5',
    title: '深海',
    category: 'animation',
    year: 2025,
    rating: 9.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20dreamy%20underwater%20fantasy%20colorful%20ink%20painting%20style%20particle%20effects%20artistic%20warm%20golden%20coral%20tones%20cinematic%20composition&width=600&height=840&seq=movie-shenhai&orientation=portrait',
    imageSeq: 'movie-shenhai',
    description: '国产动画美学巅峰之作，粒子水墨技术打造瑰丽深海幻境。',
    director: '田晓鹏',
    cast: ['苏鑫', '王亭文', '滕奎兴', '杨婷', '吉静'],
    genre: ['动画', '奇幻', '冒险'],
    duration: '112分钟',
    region: '中国大陆',
    synopsis: '一个沉浸在自己世界中的小女孩参宿，意外坠入了一个由她内心世界构建的奇幻深海。在那里，她遇到了神秘少年南河，两人在五彩斑斓的水下世界中展开了一段关于成长、勇气和救赎的奇妙旅程。全片采用革命性的粒子水墨技术，每一帧都美得像一幅画。',
    featured: true,
    isNew: false,
  },
  {
    id: 'movie-6',
    title: '我爱你！',
    category: 'romance',
    year: 2025,
    rating: 8.9,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20romantic%20drama%20movie%20poster%20elderly%20love%20story%20warm%20sunset%20golden%20red%20tones%20tender%20emotional%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=movie-woaini&orientation=portrait',
    imageSeq: 'movie-woaini',
    description: '黄昏恋情感人至深，两对老年恋人的温暖爱情故事。',
    director: '韩延',
    cast: ['倪大红', '惠英红', '梁家辉', '叶童'],
    genre: ['爱情', '剧情'],
    duration: '116分钟',
    region: '中国大陆/中国香港',
    synopsis: '空巢老人常为戒和拾荒老太李慧如在公园偶遇，两颗孤独的心渐渐靠近。另一边，年迈的谢定山不离不弃地照顾患阿尔茨海默症的妻子赵欢欣。两段关于爱与陪伴的黄昏恋，在夕阳余晖中散发出最温暖的光芒。',
    featured: false,
    isNew: true,
  },
  {
    id: 'movie-7',
    title: '封神第二部',
    category: 'action',
    year: 2026,
    rating: 9.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%20ancient%20warriors%20gods%20battle%20dramatic%20golden%20red%20tones%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy%20title&width=600&height=840&seq=movie-fengshen2&orientation=portrait',
    imageSeq: 'movie-fengshen2',
    description: '神话史诗续作，商周大战全面爆发，神仙斗法场面宏大。',
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰'],
    genre: ['动作', '奇幻', '史诗'],
    duration: '155分钟',
    region: '中国大陆',
    synopsis: '姬发在姜子牙的辅佐下回到西岐，举起反商大旗。纣王殷寿暴虐更甚，闻仲率大军压境。西岐军民浴血奋战，神魔两道纷纷下界参战。一场决定天下归属的封神大战全面爆发，英雄与神魔的命运在战火中交织。',
    featured: true,
    isNew: true,
  },
  {
    id: 'movie-8',
    title: '热辣滚烫',
    category: 'comedy',
    year: 2025,
    rating: 8.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20inspirational%20comedy%20movie%20poster%20boxing%20theme%20warm%20golden%20red%20tones%20empowering%20energy%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=movie-rela&orientation=portrait',
    imageSeq: 'movie-rela',
    description: '励志喜剧温暖人心，一个女人自我蜕变的感人故事。',
    director: '贾玲',
    cast: ['贾玲', '雷佳音', '张小斐', '杨紫', '沙溢'],
    genre: ['喜剧', '剧情', '励志'],
    duration: '129分钟',
    region: '中国大陆',
    synopsis: '善良的乐莹在经历了一连串生活的打击后，遇到了拳击教练昊坤。在昊坤的激励下，乐莹决定改变自己的人生。她从零开始学习拳击，在汗水与泪水中完成了令人惊叹的身心蜕变，最终找到了属于自己的舞台和人生方向。',
    featured: false,
    isNew: false,
  },
  {
    id: 'movie-9',
    title: '明日战记',
    category: 'scifi',
    year: 2025,
    rating: 8.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20sci-fi%20action%20movie%20poster%20mecha%20robot%20futuristic%20city%20dark%20metallic%20tones%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=movie-mingri&orientation=portrait',
    imageSeq: 'movie-mingri',
    description: '港式科幻动作巨制，机甲战士激战外星生物。',
    director: '吴炫辉',
    cast: ['古天乐', '刘青云', '刘嘉玲', '姜皓文', '谢君豪'],
    genre: ['科幻', '动作', '机甲'],
    duration: '115分钟',
    region: '中国香港',
    synopsis: '近未来，一颗陨石坠落在B16区，引发外星植物疯狂生长，城市面临毁灭性危机。机甲战队指挥官泰来率领精英小队深入污染区执行任务。然而在任务过程中，他们发现了比外星植物更可怕的阴谋——有人想借此毁灭整个城市。',
    featured: false,
    isNew: false,
  },
  {
    id: 'movie-10',
    title: '铃芽之旅',
    category: 'animation',
    year: 2025,
    rating: 8.7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20film%20poster%20Makoto%20Shinkai%20style%20beautiful%20sky%20girl%20adventure%20warm%20golden%20coral%20tones%20dreamy%20atmosphere%20cinematic%20composition&width=600&height=840&seq=movie-lingya&orientation=portrait',
    imageSeq: 'movie-lingya',
    description: '新海诚治愈系动画，少女与神秘之门跨越日本的奇幻冒险。',
    director: '新海诚',
    cast: ['原菜乃华', '松村北斗', '深津绘里', '染谷将太'],
    genre: ['动画', '奇幻', '冒险'],
    duration: '122分钟',
    region: '日本',
    synopsis: '生活在九州乡间的17岁少女铃芽，遇到了一名正在寻找"门"的神秘青年草太。追随他的脚步，铃芽在山中废墟中打开了一扇古老的门，从此各地灾难之门陆续开启。为了阻止灾难，铃芽踏上了关闭这些门的旅途，在途中她渐渐找回了自己失去的记忆。',
    featured: false,
    isNew: false,
  },
  {
    id: 'movie-11',
    title: '满江红',
    category: 'action',
    year: 2025,
    rating: 8.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20movie%20poster%20ancient%20palace%20courtyard%20dark%20crimson%20gold%20tones%20Zhang%20Yimou%20style%20dramatic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=movie-manjianghong&orientation=portrait',
    imageSeq: 'movie-manjianghong',
    description: '张艺谋导演悬疑动作大片，小兵大义的惊心密谋。',
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    genre: ['悬疑', '动作', '历史'],
    duration: '159分钟',
    region: '中国大陆',
    synopsis: '南宋绍兴年间，岳飞死后四年。秦桧率兵与金国会谈，金国使者死在宰相驻地。小兵张大与亲兵营副统领孙均被卷入这场阴谋之中，在层层迷雾中追寻真相。一夜之间，忠与奸、生与死的较量在宰相府邸中激烈展开。',
    featured: false,
    isNew: false,
  },
  {
    id: 'movie-12',
    title: '熊出没·逆转时空',
    category: 'animation',
    year: 2026,
    rating: 8.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20film%20poster%20bears%20cartoon%20colorful%20fun%20time%20travel%20theme%20warm%20bright%20tones%20cinematic%20composition%20Chinese%20calligraphy&width=600&height=840&seq=movie-xiongchumo&orientation=portrait',
    imageSeq: 'movie-xiongchumo',
    description: '熊出没系列最新力作，时空穿越带来全新冒险体验。',
    director: '林汇达',
    cast: ['张伟', '张秉君', '谭笑', '李婉瑶'],
    genre: ['动画', '喜剧', '冒险'],
    duration: '98分钟',
    region: '中国大陆',
    synopsis: '光头强意外获得了一台能够穿越时空的装置，他和熊大熊二一起穿越到了不同的时代。从远古恐龙世界到未来科技都市，他们经历了一系列惊险又搞笑的冒险。在这个过程中，他们不仅收获了珍贵的友谊，还学会了珍惜当下的美好时光。',
    featured: false,
    isNew: true,
  },
  {
    id: 'movie-13',
    title: '孤注一掷',
    category: 'horror',
    year: 2025,
    rating: 8.7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20cyber%20scam%20theme%20dark%20red%20ominous%20tones%20intense%20atmosphere%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=movie-guzhuyizhi&orientation=portrait',
    imageSeq: 'movie-guzhuyizhi',
    description: '网络诈骗题材犯罪大片，真实事件改编触目惊心。',
    director: '申奥',
    cast: ['张艺兴', '金晨', '咏梅', '王传君', '王大陆'],
    genre: ['犯罪', '惊悚', '剧情'],
    duration: '130分钟',
    region: '中国大陆',
    synopsis: '程序员潘生和模特安娜被高薪招聘吸引来到海外，却落入境外诈骗工厂的陷阱。在暴力威胁下，他们被迫成为诈骗集团的帮凶。然而随着诈骗帝国的内幕被逐渐揭开，一场惊心动魄的逃亡与救赎之旅由此展开。',
    featured: false,
    isNew: false,
  },
  {
    id: 'movie-14',
    title: '飞驰人生2',
    category: 'comedy',
    year: 2025,
    rating: 8.2,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20race%20car%20speed%20action%20warm%20golden%20red%20tones%20energetic%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=movie-feichi2&orientation=portrait',
    imageSeq: 'movie-feichi2',
    description: '赛车喜剧续作回归，沈腾尹正再度飙车笑料不断。',
    director: '韩寒',
    cast: ['沈腾', '范丞丞', '尹正', '张本煜', '孙艺洲'],
    genre: ['喜剧', '运动', '剧情'],
    duration: '121分钟',
    region: '中国大陆',
    synopsis: '曾经风光无限的赛车手张驰如今落魄潦倒，在一家驾校当教练。当他得知一个新的赛车比赛即将举办时，内心的赛车梦再次被点燃。他召集旧部、招募新人，在笑料百出的训练中准备重返赛场，却没想到等待他的是更加疯狂的挑战。',
    featured: false,
    isNew: false,
  },
  {
    id: 'movie-15',
    title: '长安三万里',
    category: 'animation',
    year: 2025,
    rating: 9.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20film%20poster%20Tang%20dynasty%20poetry%20ink%20painting%20style%20elegant%20golden%20coral%20tones%20artistic%20composition%20Chinese%20calligraphy%20title&width=600&height=840&seq=movie-changan&orientation=portrait',
    imageSeq: 'movie-changan',
    description: '诗意动画巨作，李白高适的传奇友谊，盛唐风华再现。',
    director: '谢君伟',
    cast: ['杨天翔', '凌振赫', '吴俊全', '宣晓鸣', '卢力峰'],
    genre: ['动画', '历史', '传记'],
    duration: '168分钟',
    region: '中国大陆',
    synopsis: '安史之乱后，大唐由盛转衰。年迈的高适困守孤城，向监军太监回忆起自己与李白跨越数十年的深厚友谊。从少年意气风发到暮年沧桑感慨，两人的人生轨迹见证了大唐从开元盛世到安史之乱的跌宕起伏。这是一部献给所有中国人的浪漫史诗。',
    featured: true,
    isNew: false,
  },
  {
    id: 'movie-16',
    title: '八角笼中',
    category: 'action',
    year: 2025,
    rating: 8.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20realistic%20drama%20movie%20poster%20boxing%20cage%20fighting%20raw%20earthy%20tones%20gritty%20atmosphere%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=movie-bajiaolong&orientation=portrait',
    imageSeq: 'movie-bajiaolong',
    description: '王宝强导演现实主义力作，贫困少年格斗逆袭之路。',
    director: '王宝强',
    cast: ['王宝强', '陈永胜', '史彭元', '王迅', '张祎曈'],
    genre: ['剧情', '动作', '励志'],
    duration: '117分钟',
    region: '中国大陆',
    synopsis: '向腾辉倾注心血，把一群大山里的贫困少年培养成格斗冠军。然而随着一段训练视频在网络爆红，他们被推上了舆论的风口浪尖。面对误解、质疑和重重阻力，向腾辉和孩子们用拳头和汗水证明了——出身不能决定命运，拼搏才能改变人生。',
    featured: false,
    isNew: false,
  },
  {
    id: 'tv-1',
    title: '狂飙',
    category: 'tvseries',
    year: 2025,
    rating: 9.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20underworld%20police%20confrontation%20dark%20gold%20red%20tones%20intense%20atmosphere%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=tv-kuangbiao&orientation=portrait',
    imageSeq: 'tv-kuangbiao',
    description: '年度现象级扫黑大剧，张颂文张译飙戏炸裂，口碑封神。',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    genre: ['剧情', '犯罪', '扫黑'],
    duration: '39集',
    region: '中国大陆',
    synopsis: '京海市一线刑警安欣在与黑恶势力的斗争中，遭遇了重重阻力。横跨二十年的时空，黑白交锋从未停歇。从街头混混到黑帮大佬的高启强，与坚守正义的安欣之间展开了一场跨越时代的正邪较量。这是一部关于人性、权力与正义的史诗巨制。',
    featured: true,
    isNew: false,
  },
  {
    id: 'tv-2',
    title: '三体',
    category: 'tvseries',
    year: 2026,
    rating: 9.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20three%20body%20problem%20cosmic%20mysterious%20dark%20metallic%20gold%20tones%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=tv-santi&orientation=portrait',
    imageSeq: 'tv-santi',
    description: '刘慈欣科幻巨著改编，宇宙级想象力震撼呈现。',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    genre: ['科幻', '悬疑', '剧情'],
    duration: '30集',
    region: '中国大陆',
    synopsis: '纳米科学家汪淼被警官史强带到联合作战中心，卷入了一场关于外星文明的秘密调查。随着调查的深入，"三体"世界的真相逐渐浮出水面。与此同时，一段跨越半个世纪的人类与外星文明初次接触的历史被揭开，一场关乎地球命运的对决悄然开启。',
    featured: true,
    isNew: true,
  },
  {
    id: 'tv-3',
    title: '庆余年第二季',
    category: 'tvseries',
    year: 2026,
    rating: 9.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20political%20drama%20TV%20series%20poster%20ancient%20palace%20intrigue%20elegant%20golden%20red%20tones%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=tv-qingyunian2&orientation=portrait',
    imageSeq: 'tv-qingyunian2',
    description: '权谋古装巨制回归，范闲身世之谜终将揭晓。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    genre: ['古装', '权谋', '剧情'],
    duration: '36集',
    region: '中国大陆',
    synopsis: '范闲在解决了抱月楼的危机后，权力和地位都达到了新的高度。然而他母亲的死因和他自己的身世之谜仍然笼罩着他。在庆帝、检察院、北齐等多方势力的博弈中，范闲不断成长，逐步揭开了一个震撼天下的惊天秘密。',
    featured: false,
    isNew: true,
  },
  {
    id: 'tv-4',
    title: '繁花',
    category: 'tvseries',
    year: 2025,
    rating: 9.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%20Shanghai%201990s%20nostalgic%20golden%20warm%20tones%20Wong%20Kar-wai%20style%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=tv-fanhua&orientation=portrait',
    imageSeq: 'tv-fanhua',
    description: '王家卫首部电视剧，胡歌主演上海滩商战传奇。',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '郑恺'],
    genre: ['剧情', '爱情', '商战'],
    duration: '30集',
    region: '中国大陆',
    synopsis: '上世纪九十年代初，上海滩风云变幻。阿宝凭借敏锐的商业嗅觉和过人胆识，在黄河路上打拼出一片天地。他与玲子、汪小姐、李李三位女性的情感纠葛，见证了那个时代的商业传奇与人世繁华。这是一部献给上海这座城市的时代情书。',
    featured: false,
    isNew: false,
  },
  {
    id: 'movie-17',
    title: '地球脉动III',
    category: 'documentary',
    year: 2026,
    rating: 9.7,
    imageUrl: 'https://readdy.ai/api/search-image?query=BBC%20nature%20documentary%20poster%20wildlife%20animals%20planet%20earth%20vibrant%20natural%20colors%20epic%20landscape%20cinematic%20composition%20film%20grain%20texture&width=600&height=840&seq=doc-earth3&orientation=portrait',
    imageSeq: 'doc-earth3',
    description: 'BBC纪录大片第三季，前所未有的自然奇观视觉盛宴。',
    director: 'BBC自然历史部',
    cast: ['大卫·爱登堡'],
    genre: ['纪录片', '自然'],
    duration: '8集',
    region: '英国',
    synopsis: '历时5年制作，走遍全球43个国家，使用最先进的拍摄技术，捕捉动物世界中前所未见的精彩瞬间。从深海的奇异生物到极地的冰雪世界，从热带雨林的繁茂生态到沙漠中的生命奇迹，带您领略地球最壮美的自然奇观。',
    featured: true,
    isNew: true,
  },
  {
    id: 'movie-18',
    title: '独行月球',
    category: 'comedy',
    year: 2025,
    rating: 8.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20comedy%20movie%20poster%20astronaut%20on%20moon%20humorous%20lonely%20warm%20golden%20red%20tones%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=movie-duxing&orientation=portrait',
    imageSeq: 'movie-duxing',
    description: '沈腾马丽科幻喜剧，月球上的爆笑求生之旅。',
    director: '张吃鱼',
    cast: ['沈腾', '马丽', '黄才伦', '常远', '辣目洋子'],
    genre: ['喜剧', '科幻', '剧情'],
    duration: '122分钟',
    region: '中国大陆',
    synopsis: '人类为抵御小行星撞击，在月球部署了月盾计划。陨石提前来袭，全员紧急撤离时，维修工独孤月因为意外错过了撤离通知，一个人被遗忘在了月球上。他以为自己成了"宇宙最后的人类"，在月球上展开了一段啼笑皆非的求生之旅。',
    featured: false,
    isNew: false,
  },
  {
    id: 'movie-19',
    title: '坚如磐石',
    category: 'action',
    year: 2025,
    rating: 8.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20movie%20poster%20corruption%20political%20dark%20red%20black%20tones%20Zhang%20Yimou%20style%20intense%20atmosphere%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=movie-jianru&orientation=portrait',
    imageSeq: 'movie-jianru',
    description: '张艺谋首部犯罪悬疑片，官商勾结暗流涌动。',
    director: '张艺谋',
    cast: ['雷佳音', '张国立', '于和伟', '周冬雨', '孙艺洲'],
    genre: ['犯罪', '悬疑', '剧情'],
    duration: '128分钟',
    region: '中国大陆',
    synopsis: '技术科警察苏见明在调查一起公交车爆炸案时，发现背后隐藏着更大的阴谋。随着调查深入，他惊讶地发现这些线索竟直指自己身为高官的父亲和富商黎志田之间的权钱交易。在正义与亲情之间，苏见明被迫做出艰难的抉择。',
    featured: false,
    isNew: false,
  },
  {
    id: 'movie-20',
    title: '奇迹·笨小孩',
    category: 'romance',
    year: 2025,
    rating: 8.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20inspirational%20drama%20movie%20poster%20young%20entrepreneur%20Shenzhen%20warm%20golden%20hopeful%20tones%20cinematic%20composition%20film%20grain%20texture%20Chinese%20calligraphy&width=600&height=840&seq=movie-qiji&orientation=portrait',
    imageSeq: 'movie-qiji',
    description: '文牧野导演暖心力作，小人物大梦想的奋斗故事。',
    director: '文牧野',
    cast: ['易烊千玺', '田雨', '陈哈琳', '齐溪', '公磊'],
    genre: ['剧情', '励志'],
    duration: '106分钟',
    region: '中国大陆',
    synopsis: '二十岁的景浩带着年幼的妹妹来到深圳，为了凑齐妹妹的手术费，他必须在一年半内赚到50万。机缘巧合下，他获得了一个看似不可能完成的任务——翻新一批残次品手机。在毫无退路的情况下，景浩组建了一支由社会边缘人组成的"奇迹小队"，开始了充满艰辛的创业之路。',
    featured: false,
    isNew: false,
  },
];

export const faqItems = [
  { q: '八戒影院的视频需要付费吗？', a: '不需要！八戒影院所有的影视内容都是免费观看的，无需注册登录，无需支付任何费用。我们致力于为广大影迷提供最便捷的免费观影渠道。' },
  { q: '影片画质如何？会不会卡顿？', a: '我们提供的影片均为高清画质，支持1080P甚至更高分辨率。平台采用先进的CDN加速技术，确保播放流畅不缓冲，给您极致的观影体验。' },
  { q: '影片更新速度快吗？', a: '非常快！我们的内容团队每日跟进各大影视平台的最新动态，第一时间更新热门电影和电视剧，确保您不会错过任何精彩内容。' },
  { q: '支持哪些设备观看？', a: '八戒影院支持电脑、平板、手机等多种设备观看，采用响应式设计，自动适配不同屏幕尺寸，让您随时随地畅享影视盛宴。' },
  { q: '如何找到我想看的影片？', a: '您可以通过首页的分类导航按类型筛选影片，也可以使用搜索功能直接查找。我们的影片分类清晰，查找方便快捷。' },
  { q: '电视剧更新到第几集了？', a: '我们与各大平台保持同步更新，热门电视剧全集第一时间上线。您可以在电视剧专区查看最新的更新进度和播放列表。' },
];

export const testimonials = [
  { name: '电影爱好者小王', text: '自从发现了八戒影院，再也不用四处找资源了！画质清晰，更新又快，强烈推荐！', rating: 5 },
  { name: '追剧达人小李', text: '追剧神器！热门电视剧同步更新，不用等不用充会员，简直太良心了。', rating: 5 },
  { name: '家庭观影用户张先生', text: '周末全家一起看电影，八戒影院的影片种类丰富，老人孩子都能找到喜欢的，非常满意。', rating: 5 },
  { name: '大学生小陈', text: '室友推荐给我的，免费的还这么高清，看科幻片特效简直不要太爽！', rating: 5 },
  { name: '上班族刘女士', text: '下班回家追一集电视剧，画面流畅不卡顿，比花钱的视频网站体验还好。', rating: 4 },
  { name: '退休教师周叔叔', text: '儿子帮我设置的，界面简单好操作，每天看看老电影回忆青春，很幸福。', rating: 5 },
];